<template>
  <div class="input-field">
    <input
      class="input-field__input"
      v-model="model"
      :id="props.inputId"
      v-bind="inputAttrs"
      :class="inputClass"
      :maxlength="props.maxlength"
      :disabled="props.disabled"
      @focus="onFocus"
      @blur="onBlur"
    />
    <span
      v-show="
        maxlength && !disabled && (focused || model?.length > props.maxlength!)
      "
      class="input-field__counter"
      :class="{ limit: model?.length >= props.maxlength! }"
      >{{ model?.length }} / {{ props.maxlength }}</span
    >
  </div>
</template>

<script setup lang="ts">
import { computed, ref, useAttrs } from "vue";

const props = defineProps<{
  inputId?: string;
  inputClass?: string;
  maxlength?: number;
  disabled?: boolean;
}>();

const attrs = useAttrs();
const model = defineModel<any>();
const focused = ref(false);

const inputAttrs = computed(() =>
  Object.fromEntries(
    Object.entries(attrs).filter(([key]) => key !== "class" && key !== "id")
  )
);

const onFocus = () => {
  focused.value = true;
};

const onBlur = () => {
  focused.value = false;
};
</script>

<style scoped lang="scss">
.input-field {
  position: relative;

  &__input {
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 0.5rem;
    width: 100%;
    font-size: 1rem;
    transition: border-color 0.2s;
    &:focus {
      border-color: #007bff;
    }
  }

  &__counter {
    font-size: 0.8rem;
    color: #666;
    margin-top: 0.25rem;
    display: block;
    position: absolute;
    right: 0;
    &.limit {
      color: #dc3545;
    }
  }
}
</style>
